define('sentient/aba/models/WindowModel',[
	'underscore',
	'jquery',
	'backbone'
	], function(_, $, Backbone) {
		var WindowModel = Backbone.Model.extend({
			defaults: {
			},
			initialize: function() {},
			updateValuesFromEnv: function(sessionView, window) {
				var $sessionView = $(sessionView);
				var $window = $(window);
				this.set({
					'width': $sessionView.width(),
					'height': $sessionView.height(),
					'size': {
						'width': $sessionView.width(),
						'height': $sessionView.height()
					},
					'windowWidth': $window.width(),
					'windowHeight': $window.height(),
					'windowSize': {
						'width': $window.width(),
						'height': $window.height()
					}
				});
			}
		});
		return WindowModel;
	});

